"use client";

import { Vacancy } from "@entities/vacancy";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { AuthenticationDialog } from "./authentication-dialog";
import { DefaultApplyAction } from "./default-apply-action";
import { ExternalApplyAction } from "./external-apply-action";
import { JobSeekerDialog } from "./job-seeker-dialog";
import { ProfileCompleteDialog } from "./profile-completion-dialog";
import { Proposal } from "@entities/proposal";

export function VacancyApplyAction({ vacancy, onSucceed }: { vacancy: Vacancy; onSucceed: (response: Proposal) => void }) {
  const clientConfig = useClientConfig();

  const nacoUser = clientConfig?.nacoUser;
  const user = clientConfig?.user;

  if (!nacoUser || !user || !user.profile) {
    return (
      <div>
        <AuthenticationDialog />
      </div>
    );
  }

  if (user.profile.status === "new") {
    return (
      <div>
        <ProfileCompleteDialog />
      </div>
    );
  }

  if (!user.profile.lookingForJob) {
    return (
      <div>
        <JobSeekerDialog />
      </div>
    );
  }

  if (vacancy.platformType === "external") {
    return <ExternalApplyAction vacancy={vacancy} onSucceed={onSucceed} />;
  }

  return <DefaultApplyAction vacancy={vacancy} onSucceed={onSucceed} />;
}
